module.exports = __webpack_public_path__ + "fonts/a85caa1fd71a808a2f1983197b033b08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/img/icon_europe_unselected_area3.svg
// module id = 1533
// module chunks = 0